import * as React from "react";
import type { SVGProps } from "react";
const SvgDining = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={27}
    fill="none"
    {...props}
  >
    <g fill="#050033" clipPath="url(#dining_svg__a)">
      <path d="M10.479 1.176C6.48 5.935 7.704 9.812 9.21 12.075v12.96c0 .37.304.674.674.674h.607c.37 0 .674-.304.674-.674V1.425a.389.389 0 0 0-.687-.25M5.42 1.808c-.241.04-.407.266-.407.51v5.88a.593.593 0 1 1-1.186 0v-5.88c0-.244-.165-.47-.407-.51a.49.49 0 0 0-.572.483v5.907a.593.593 0 1 1-1.187 0v-5.88c0-.244-.165-.47-.407-.51a.49.49 0 0 0-.572.483v7.054c0 1.12.696 2.079 1.678 2.467v13.222c0 .37.304.675.674.675h.607c.37 0 .674-.304.674-.675V11.812a2.66 2.66 0 0 0 1.678-2.467V2.29a.49.49 0 0 0-.573-.483" />
    </g>
    <defs>
      <clipPath id="dining_svg__a">
        <path fill="#fff" d="M.469.344h10.938v26.25H.469z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDining;
